import { getSdk } from "./sdkService";
import { config } from "../config/config";
import { getAppState } from "../state/index";

/**
 * Checks if there is some choice -saved on localStorage (in case it's available)- made by the user
 * to determine if she/he wants voucher related screens to be showed or not.
 * @param {Boolean} isLocalStorageDependant - Value that determines if localStorage is needed to be checked.
 * @returns {Boolean} Value that determines if voucher related screens/flows shall be shown or not.
 * @private
 */
function checkLocalStorageDependency(isLocalStorageDependant) {
  const isShowingEnabled =
    (localStorage && localStorage.getItem("showVoucherPopup") === null && true) ||
    JSON.parse(localStorage.getItem("showVoucherPopup"));
  return isLocalStorageDependant ? isShowingEnabled : true;
}

/**
 * Checks device eVoucher eligibility and returns voucher data in case it exists and eVoucher
 * functionality is active from config file. If not, returns false.
 * @returns {Object|Boolean} - Voucher data object or false in case there is no object voucher data retrieved.
 * @public
 */
export async function checkVoucherEligiblity(isLocalStorageDependant = true) {
  try {
    if (config.get().featureToggles.eVoucher) {
      const isShowingEnabled = checkLocalStorageDependency(isLocalStorageDependant);
      const voucherEligibility = await getSdk().userManager.checkVoucherEligiblity();

      if (isShowingEnabled === true && voucherEligibility && voucherEligibility.redeemed === false) {
        getAppState().voucherData = voucherEligibility;
        return voucherEligibility;
      }
      return false;
    }
    return false;
  } catch (e) {
    return false;
  }
}

export async function checkeVoucherLGEligiblity(country) {
  try {
    let savedVoucherEligibilityData = localStorage.getItem("voucherData");
    if (
      savedVoucherEligibilityData &&
      savedVoucherEligibilityData !== "false" &&
      savedVoucherEligibilityData !== false
    ) {
      savedVoucherEligibilityData = JSON.parse(savedVoucherEligibilityData);
      if (isVoucherNotExpired(savedVoucherEligibilityData)) {
        getAppState().voucherData = savedVoucherEligibilityData;
        return savedVoucherEligibilityData;
      }
    }
  } catch (e) {
    throw e;
  }

  try {
    //const voucherEligibility = {"status":"VALID","vouchers":[{"subscriptions":["starzplay"],"expirationTimestamp":"2023-11-27","duration":"M03","code":"W01SBST23014916A334"}]};//
    const voucherEligibility = await getSdk().userManager.checkEvoucherEligiblity(country);
    getAppState().voucherData = voucherEligibility;
    localStorage.setItem("voucherData", JSON.stringify(voucherEligibility));
    return voucherEligibility;
  } catch (e) {
    throw e;
  }
}

export async function eVoucherProvisioning(baseVoucherCode, addonVoucherCode) {
  try {
    const voucherEligibility = await getSdk().userManager.eVoucherProvision(baseVoucherCode, addonVoucherCode);
    const updatedUser = await getSdk().userManager.get({ avoidCache: true });
    return {
      ...voucherEligibility,
      ...updatedUser
    };
  } catch (e) {
    e.customCode = "ProvisioningError";
    localStorage.removeItem("voucherData");
    throw e;
  }
}

export async function updatePromotionShown() {
  try {
    const voucherPromotionShown = await getSdk().userManager.promotionShown();
    if (!voucherPromotionShown || (voucherPromotionShown && voucherPromotionShown.error_code)) {
      return false;
    }
    return voucherPromotionShown;
  } catch (e) {
    return false;
  }
}

export async function getEvoucherDeviceVailidity(platform = "lg-webos") {
  try {
    const evoucherDeviceVailidity = await getSdk().userManager.getEvoucherDeviceVailidity(platform);
    return evoucherDeviceVailidity;
  } catch (e) {
    return false;
  }
}

function isVoucherNotExpired(savedVoucherEligibilityData) {
  const currentDate = new Date();
  const expirationDate = new Date(savedVoucherEligibilityData.vouchers[0].expirationTimestamp);
  return expirationDate >= currentDate;
}
